import * as React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { isMultiCity as getIsMultiCity, getSegments } from '@websky/core/src/SearchForm/store/segments/selectors';
import Segment from './Segment/Segment';
import css from './Segments.css';
const Segments = React.memo(() => {
    const isMultiCity = useSelector(getIsMultiCity);
    const segments = useSelector(getSegments);
    return (React.createElement("div", { className: cn(css.container, {
            [css.container_multiCity]: isMultiCity
        }) }, segments.map((_, index) => (React.createElement(Segment, { key: index, segmentId: index })))));
});
export default Segments;
